import { Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { MaintenanceSlaContractRecord } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';
import { useMaintenanceSlaScopeColumns } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/hooks/useMaintenanceSlaScopeColumns';
import { useMaintenanceSlaScopeOptions } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/hooks/useMaintenanceSlaScopeOptions';

export interface MaintenanceSlaScopeRulesReadProps {
  organizationId: string;
  contract: MaintenanceSlaContractRecord;
}

export function MaintenanceSlaScopeRulesRead({
  organizationId,
  contract,
}: MaintenanceSlaScopeRulesReadProps) {
  const { t } = useTranslation('sla');
  const scopeOptions = useMaintenanceSlaScopeOptions(organizationId);
  const columns = useMaintenanceSlaScopeColumns(
    (rule) => scopeOptions.labelFor(rule.dimension, rule.value),
    contract.interventionMode,
  );

  return (
    <div style={{ marginTop: 16 }}>
      <Typography.Text className="ds-section-header">
        {t('oems.maintenance.sections.scopeRules')}
      </Typography.Text>
      {contract.scopeRules.length === 0 ? (
        <Typography.Paragraph type="secondary">
          {t('oems.maintenance.noScopeRules')}
        </Typography.Paragraph>
      ) : (
        <Table
          size="small"
          pagination={false}
          rowKey="id"
          dataSource={contract.scopeRules}
          columns={columns}
        />
      )}
    </div>
  );
}
